import { useHistory } from 'react-router-dom';
import { getConfig } from '../../../utils/config';
import { useSelector } from 'react-redux';

const ReferralFormBanner = () => {
    const config = getConfig();
    const history = useHistory();
    const isInternalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    return (
        <section
            id="referral_section"
            className={`${
                config?.referralForm?.height
                    ? config?.referralForm?.height
                    : 'h-[70vh] lg:h-[60vh]'
            } relative`}
        >
            <div
                className={`absolute ${
                    config?.referralForm?.removeBlur ? '' : 'blur-sm'
                } hero w-full h-full`}
                style={{
                    backgroundImage: `linear-gradient(${config?.referralForm?.linearGradient.degree}, rgba(${config?.referralForm?.linearGradient?.R1}, ${config?.referralForm?.linearGradient.G1}, ${config?.referralForm?.linearGradient.B1}, ${config?.referralForm?.linearGradient.opacity1}),rgba(${config?.referralForm?.linearGradient?.R2}, ${config?.referralForm?.linearGradient.G2}, ${config?.referralForm?.linearGradient.B2}, ${config?.referralForm?.linearGradient.opacity2})), url(${config?.referralForm?.backgroundImage})`,
                    zIndex: '0'
                }}
            ></div>
            <div className="grid grid-cols-1 lg:grid-cols-2 lg:justify-center h-full">
                <div className="flex item-center justify-center w-full lg:w-[80%] mx-auto">
                    <h1
                        className={`col-span-1 text-center z-10 
                   ${
                       config?.referralForm?.formContent.headingClass
                           ? config?.referralForm?.formContent.headingClass
                           : 'text-white self-center font-brandFont text-4xl sm:text-5xl 2xl:text-6xl w-[80%] lg:w-full xl:w-[80%] font-semibold text-center tracking-widest'
                   }`}
                    >
                        {config?.referralForm?.formContent.heading}
                    </h1>
                </div>
                <div className="flex lg:items-center justify-center w-[80%] mx-auto self-start lg:self-center">
                    <button
                        className={`${
                            config?.referralForm?.formContent.loginButton
                                ? config?.referralForm?.formContent.loginButton
                                : 'text-white border-4 font-semibold'
                        }  col-span-1 self-center relative py-5 px-10`}
                        onClick={() => {
                            if (isInternalWebview && isIOS) {
                                var valueToSend = {
                                    type: 'OPEN_REFERRAL_IN_BROWSER'
                                };
                                window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                                    valueToSend
                                );
                            } else {
                                history.push('/gift-and-earn');
                            }
                        }}
                        style={{
                            borderImage: `url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100' fill='none'%3E%3Cstyle%3Epath%7Banimation:stroke 5s infinite linear;%7D@keyframes stroke%7Bto%7Bstroke-dashoffset:776;%7D%7D%3C/style%3E%3ClinearGradient id='g' x1='0%25' y1='0%25' x2='0%25' y2='100%25'%3E%3Cstop offset='100%25' stop-color='white'/%3E%3C/linearGradient%3E%3Cpath d='M1.5 1.5 l97 0l0 97l-97 0 l0 -97' stroke='%23${config?.primaryColor.slice(
                                1
                            )}' stroke-width='7' fill='none' /%3E%3Cpath d='M1.5 1.5 l97 0l0 97l-97 0 l0 -97' stroke-linecap='square' stroke='url(%23g)' stroke-width='7' stroke-dasharray='388'/%3E%3C/svg%3E") 1 `
                        }}
                    >
                        Refer Now
                    </button>
                </div>
            </div>
            <div
                className={`flex absolute w-full lg:w-auto justify-center lg:mx-0 bottom-2 lg:left-6`}
            >
                <p className=" text-white text-sm lg:text-xs xl:text-sm mr-2 justify-between self-end">
                    Powered by
                </p>
                <div>
                    <img
                        className="h-7 lg:h-5 xl:h-7 self-center"
                        src="https://cdn.loyalie.in/1743407605085_reloy_new_logo"
                    />
                </div>
            </div>
        </section>
    );
};
export default ReferralFormBanner;
